export class LevelDescription {

    public street: string;
    public supplement: string;
    public zipcode: string;
    public city: string;
    public country: string;
    public email: string;
    public phone: string;
    public contact_name: string;
    public contact_email: string;
    public contact_phone: string;
    public notes: string;

    constructor() {

    }

}
